import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowUp } from "lucide-react";

export const BackToTop = ({ onClick }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 500);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.button
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 16 }}
          transition={{ duration: 0.25, ease: [0.22, 1, 0.36, 1] }}
          onClick={onClick}
          data-testid="back-to-top"
          aria-label="Zpět nahoru"
          className="fixed bottom-5 right-5 sm:bottom-7 sm:right-7 z-[60] grid place-items-center h-11 w-11 sm:h-12 sm:w-12 rounded-full bg-brand-orange text-white shadow-lg shadow-brand-orange/30 hover:bg-brand-navy2 hover:-translate-y-0.5 transition-all duration-300"
        >
          <ArrowUp className="h-5 w-5" strokeWidth={2.6} />
        </motion.button>
      )}
    </AnimatePresence>
  );
};

export default BackToTop;
